import React from 'react';
import styles from './style.module.scss';

const Items = ({ children }) => {
  return <div className={styles['items']}>{children}</div>;
};

export default Items;
